import { Component, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { forkJoin } from 'rxjs';
import { TipoRespaldoService } from '../../_services/tipo-respaldo.service';
import { TipoRespaldo } from '../../_models/tipo-respaldo';
import { TipoRespaldoCategoria } from '../../_models/tipo-respaldo-categoria';
import { TipoRespaldoSubcategoria } from '../../_models/tipo-respaldo-subcategoria';
import { TipoRespaldoSubcategoriaDetalle } from '../../_models/tipo-respaldo-subcategoria-detalle';

@Component( {
  selector: 'app-tipo-respaldo-editar',
  templateUrl: 'tipo-respaldo-editar.component.html'
} )

export class TipoRespaldoEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  tipoRespaldo: TipoRespaldo;
  respaldoCategoria: TipoRespaldoCategoria;
  respaldoSubcategoria: TipoRespaldoSubcategoria;
  lisTipoRespaldo: TipoRespaldo[] = [];
  tabSeleccionado = 'RESP';
  formulario: FormGroup;
  submitted = false;

  constructor( private serTipoRespaldo: TipoRespaldoService,
               private navServicio: NavService,
               private route: ActivatedRoute,
               private location: Location,
               private fb: FormBuilder,
               private autServicio: AutenticacionService,
               private conServicio: ConfirmationService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.serTipoRespaldo.obtenerPorId( params[ 'id' ] ).subscribe( tipoRespaldo => {
          this.tipoRespaldo = tipoRespaldo;
          this.carServiciosIniciales();
        } );
      } else {
        this.carServiciosIniciales();
      }
    } );
  }

  carServiciosIniciales() {
    this.formulario = this.fb.group( {
      idTipoRespaldo: [ this.tipoRespaldo ? this.tipoRespaldo.idTipoRespaldo : null ],
      codigo: [ this.tipoRespaldo ? this.tipoRespaldo.codigo : null, [ Validators.required ] ],
      nombre: [ this.tipoRespaldo ? this.tipoRespaldo.nombre : null, [ Validators.required ] ],
      descripcion: [ this.tipoRespaldo ? this.tipoRespaldo.descripcion : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.tipoRespaldo ? this.tipoRespaldo.indicadorHabilitado : false, [ Validators.required ] ],
    } );

    forkJoin( this.serTipoRespaldo.listado() ).subscribe( ( [ tipoRespaldo ] ) => {
      this.lisTipoRespaldo = tipoRespaldo;
      this.carInformacionInicial = false;
    } );

  }

  onSubmit() {
    this.submitted = true;
    if ( !this.codExiste && this.formulario.valid ) {
      this.guardando = true;
      const formulario = this.formulario.getRawValue();
      if ( formulario.idTipoRespaldo ) {
        /** Actualizar seguro */
        this.serTipoRespaldo.actualizar( formulario ).subscribe( tipoRespaldoActualizado => {
          this.tipoRespaldo = tipoRespaldoActualizado;
          this.guardando = false;
          this.submitted = false;
          this.navServicio.setMesage( 0, {
            severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_ACTUALIZO' )
          } );
          this.cambiarTabSeleccionado( 'CATE' );
        } );
      } else {
        /** Crea seguro */
        this.serTipoRespaldo.crear( formulario ).subscribe( tipoRespaldoNuevo => {
          this.tipoRespaldo = tipoRespaldoNuevo;
          this.guardando = false;
          this.submitted = false;
          this.navServicio.setMesage( 0, {
            severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_CREO' )
          } );
          this.cambiarTabSeleccionado( 'CATE' );
        } );
      }

    } else if ( this.codExiste ) {
      this.navServicio.setMesage( 0, {
        severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_ERRORCOD' )
      } );
    }
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  validarCodigo() {
    this.codExiste = this.lisTipoRespaldo.find( x => x.codigo === this.f.codigo.value ) ? true : false;
  }

  get f() {
    return this.formulario.controls;
  }

  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'RESP';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'CATE';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'SUBC';
        break;
      }
      case 3: {
        this.tabSeleccionado = 'CLAS';
        break;
      }
      default: {
        break;
      }
    }
  }

  cambiarTabSeleccionado( tab: string ) {
    this.tabSeleccionado = tab;
  }

  recibirCategoria( event: TipoRespaldoCategoria ) {
    this.respaldoCategoria = event;
  }

  recibirSubcategoria( event: TipoRespaldoSubcategoria ) {
    this.respaldoSubcategoria = event;
  }

  recibirTabSubcategoria( tab: string ) {
    this.tabSeleccionado = tab;
  }

  recibirTabClase( tab: string ) {
    this.tabSeleccionado = tab;
  }


}
